import { useFilterData } from '../../filterContext';
import { useTranslation } from 'react-i18next';
import { format, isToday, isValid } from 'date-fns';

/**
 * The text that's on the button that opens the picker up.
 */
export const useMakeMainButtonText = () => {
  const [t] = useTranslation(['search', 'translation']);
  const { commonFilterState } = useFilterData();
  const { startDate, endDate } = commonFilterState;

  const selectDateRangeText = t('Select date range', {
    ns: 'search',
    defaultValue: 'Select date range',
  });

  if (!startDate || !endDate || !isValid(startDate) || !isValid(endDate)) {
    return selectDateRangeText;
  }

  const today = t('Today', {
    ns: 'search',
    defaultValue: 'Today',
  });

  const startDateText = isToday(startDate) ? today : format(startDate, 'PP');
  const endDateText = isToday(endDate) ? today : format(endDate, 'PP');

  /** The actual label that's on the button that opens the the picker up */
  return `${selectDateRangeText}`; // (${startDateText} - ${endDateText})`;
};
